import nprogress from './plugins/nprogress'
import router from '@/router'
import { useUserInfoStore } from './stores/modules/user'
import { getItem } from './utils/storage'

// 标记动态路由是否已添加（页面刷新后重置）
let dynamicRoutesAdded = false
// 白名单：不需要登录即可访问的页面
const whiteList = ['/login']

router.beforeEach(async (to, from, next) => {
  nprogress.start()
  const userStore = useUserInfoStore()
  const token = getItem('token')

  if (token) {
    if (to.path === '/login') {
      next({ path: '/heating/devices' })
    } else {
      if (JSON.stringify(userStore.user) == '{}') {
        try {
          await userStore.getUserInfo()
        } catch (e) {
          // 后端不可用时，允许页面继续加载
          console.warn('获取用户信息失败，使用本地缓存')
        }
        dynamicRoutesAdded = true
      }
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) > -1) {
      next()
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  }
})

router.afterEach(() => {
  nprogress.done()
})
